import React, { InputHTMLAttributes, useEffect, useState } from "react";

import { useInputType } from "hooks/useInputType";
import { Masks, maskText } from "utils/mask";

import { Label } from "../Label";

import { cn } from "utils/styles";

type MaskedTextFieldProps = Omit<InputHTMLAttributes<HTMLInputElement>, 'value' | 'id' | 'onChange'> & {
  id?: string;
  label: string;
  error?: string;
  helpText?: string;
  required?: boolean
  mask?: Masks | Masks[]
  value?: string
  onChange?: (value: string) => void
  containerClassName?: string
  variant?: "primary" | "secondary"
}

export function MaskedTextField({
  label, value, type = "text", containerClassName,
  error, helpText, onChange, className, variant = 'primary',
  disabled, required, mask, id, ...props
}: MaskedTextFieldProps) {

  const [showPassword, setShowPassword] = useState(false)

  const { inputType, inputMode } = useInputType(type, showPassword)

  function handleTogglePassword() {
    setShowPassword(!showPassword);
  }

  function handleMask(event : React.ChangeEvent<HTMLInputElement>) {
    const text = event.target.value

    if (mask) {
      onChange?.(maskText(text, mask, value?.length ?? 0))
    } else {
      onChange?.(text)
    }
  }

  useEffect(() => {
    if (mask && value !== undefined) {
      onChange?.(maskText(value ?? "", mask, value?.length ?? 0))
    }
  }, [])

  return (
    <div className={cn(containerClassName, "flex flex-col w-full")}>
      { label && <Label className="px-5 mb-3">{label} {required ? "*" : ""}</Label> }
      <div className={cn('flex rounded-full', variant === 'primary' ? 'bg-primaryMultiply' : 'bg-white/30')}>
        <input
          id={id}
          name={id}
          value={value}
          onChange={handleMask}
          disabled={disabled}
          className={cn(className, "py-2 px-5 outline-none border-transparent bg-transparent w-full text-base placeholder:text-white/30")}
          type={inputType}
          inputMode={inputMode}
          {...props}
        />
        {type === "password" && 
          <img
            className="cursor-pointer mr-7"
            src={`/icons/form/password_${showPassword ? "visible" : "invisible"}.svg`} 
            onClick={handleTogglePassword}
            width="24"
            height="24"
            alt="Alterar visibilidade da senha"
          />
        }
      </div>
      {(error || helpText) && (
        <p className={cn(error ? 'text-red-500' : 'text-black', 'text-xs py-2 leading-4 px-5')}>
          {error ?? helpText}
        </p>
      )}
    </div>
  );
}